var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Paypal_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Paypal_svg__st2{display:none}.Paypal_svg__st6{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 39.5c-1.5 0-2.7-1.3-2.7-2.8V3.3C.5 1.7 1.7.5 3.2.5h57.6c1.5 0 2.7 1.3 2.7 2.8v33.3c0 1.6-1.2 2.8-2.7 2.8H3.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 1C62 1 63 2 63 3.3v33.3c0 1.3-1 2.3-2.2 2.3H3.2C2 39 1 38 1 36.7V3.3C1 2 2 1 3.2 1zm0-1H3.2C1.4 0 0 1.5 0 3.3v33.3C0 38.5 1.4 40 3.2 40h57.6c1.8 0 3.2-1.5 3.2-3.3V3.3C64 1.5 62.6 0 60.8 0",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 13.3h7c3.8 0 5.2 2 5 4.7-.3 4.7-3.2 7.2-7 7.2h-1.8c-.5 0-.8.3-1 1.3l-.8 5.3c0 .3-.2.5-.5.5H27c-.5 0-.5-.3-.5-1l2.7-17.2c.1-.4.5-.8 1.3-.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009ee3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 7.5h7.2c2 0 4.3 0 6 1.5 1 1 1.7 2.3 1.5 4-.5 5.3-3.7 8.3-8 8.3h-3.5c-.7 0-1 .3-1.2 1.5L27 29c0 .3-.2.7-.5.7H22c-.5 0-.7-.3-.5-1.2l3.2-19.8c.1-.9.5-1.2 1.3-1.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#113984"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 22.2 1.2-7.8c.2-.7.5-1 1.3-1h7c1.2 0 2.2.2 2.8.5-.7 4.8-3.8 7.5-7.8 7.5H29c-.5-.1-.8.3-1 .8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#172c70"
    }
  }));
};
export default SvgPaypal;